import * as React from 'react';
import { InfoColumn, TopBarBox } from './shared/_styles';
import { getSelectedNode } from '@src/utils';
const ElementMutators = () => {
    const component = getSelectedNode();
    return (React.createElement(TopBarBox, null,
        React.createElement(InfoColumn, null,
            component.type,
            " TODO Overrides")));
};
export default ElementMutators;
